export enum ReservationType {
    ReservationExisting = 'Existing',
    ReservationNew = 'New'
}
